export const emptyPage = {
	title: "",
	panel: ""
}